import { render } from "./CouponsForm.vue?vue&type=template&id=3b106277"
import script from "./CouponsForm.vue?vue&type=script&lang=js"
export * from "./CouponsForm.vue?vue&type=script&lang=js"

import "./CouponsForm.vue?vue&type=style&index=0&id=3b106277&lang=scss"

import exportComponent from "/srv/crewmaldives/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__